import { Candy, Droplets, Tablet } from "lucide-react";

const VAN_EXTERIOR =
  "https://customer-assets.emergentagent.com/job_e8fd11b7-6a50-45dd-b264-41dac64b79ed/artifacts/37k8850m_DJI_20250303115431_0015_D.jpg";

const AMENITIES = [
  {
    icon: Droplets,
    title: "Bouteilles d'eau",
    description: "Eau fraîche offerte à chaque passager",
  },
  {
    icon: Candy,
    title: "Friandises",
    description: "Douceurs sucrées pour agrémenter votre trajet",
  },
  {
    icon: Tablet,
    title: "iPad à disposition",
    description: "Divertissement à bord pour petits et grands",
  },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-40 bg-[#131313] overflow-hidden"
    >
      {/* Background parallax image */}
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src={VAN_EXTERIOR}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-[#131313]/80" />

      {/* Decorative gold lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/15 to-transparent" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-12">
        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left - Text */}
          <div>
            <p className="font-accent italic text-gold text-base tracking-widest mb-4">
              À propos
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-5xl text-white tracking-tight mb-8 leading-[1.1]">
              La différence<br />
              <span className="text-gold">Warner</span>
            </h2>
            <div className="gold-line w-16 mb-8" />

            <p className="text-white/70 text-base leading-[1.9] font-light tracking-wide mb-6">
              Basé à Saint-Renan, au c&oelig;ur du Finistère, Warner VTC vous propose un service 
              de transport privé haut de gamme à bord d'un Mercedes EQV 100% électrique.
            </p>

            <p className="text-white/60 text-sm leading-[1.9] font-light tracking-wide mb-6">
              Que ce soit pour un transfert vers l'aéroport de Brest, une journée de découverte 
              sur la côte bretonne, un mariage ou un déplacement professionnel, nous mettons un point 
              d'honneur à offrir un service irréprochable.
            </p>

            <p className="font-accent italic text-white/35 text-base leading-relaxed">
              Ponctualité &middot; Discrétion &middot; Confort absolu
            </p>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-4 mt-10">
              <div data-testid="about-stat-passengers">
                <span className="font-display text-3xl text-gold">7</span>
                <p className="text-white/40 text-[10px] uppercase tracking-[0.2em] mt-1">Passagers</p>
              </div>
              <div data-testid="about-stat-availability">
                <span className="font-display text-3xl text-gold">7/7</span>
                <p className="text-white/40 text-[10px] uppercase tracking-[0.2em] mt-1">Disponibilité</p>
              </div>
              <div data-testid="about-stat-electric">
                <span className="font-display text-3xl text-gold">100%</span>
                <p className="text-white/40 text-[10px] uppercase tracking-[0.2em] mt-1">Électrique</p>
              </div>
            </div>
          </div>

          {/* Right - Premium Amenities */}
          <div>
            <p className="font-accent italic text-gold/80 text-base tracking-widest mb-8">
              Inclus à bord
            </p>

            <div className="flex flex-col gap-5">
              {AMENITIES.map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div
                    key={idx}
                    data-testid={`amenity-card-${idx}`}
                    className="group relative p-7 bg-[#1E1E1E] border border-white/[0.08] hover:border-gold/25 transition-all duration-500 flex items-start gap-5"
                  >
                    <div className="absolute top-0 left-0 w-5 h-5 border-l border-t border-gold/25" />
                    <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center border border-gold/20 group-hover:border-gold/40 group-hover:bg-gold/5 transition-all duration-500">
                      <Icon size={20} className="text-gold/70 group-hover:text-gold transition-colors" strokeWidth={1.2} />
                    </div>
                    <div>
                      <h4 className="font-display text-lg text-white mb-1">
                        {item.title}
                      </h4>
                      <p className="text-white/55 text-sm font-light tracking-wide">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Premium note */}
            <div className="mt-8 p-5 border border-gold/10 bg-gold/[0.02]">
              <p className="font-accent italic text-gold/60 text-sm tracking-wide text-center">
                Chaque détail compte — votre confort est notre priorité.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
